import Router from '@/router'
import axios from 'axios'
import $ from 'jquery'
import {Message} from 'element-ui'
import XLSX from 'xlsx'
import XLSX2 from 'xlsx-style'

var env1='http://loveuu.uicp.io'
var env2='http://10.18.56.81:8080'
//备用
var env='http://10.18.52.94:10086'
//数据路径
var extra_path='/sccv2'
//背景路径
var bg_path='/bg_path'
//图片路径
var image_path='/image_path'

//模板下载前置
const exportToExcel=(excel_element,excel_name)=>{
  var xlsxParam={raw:true}
  let tables=document.querySelector(excel_element)
  let wb=XLSX.utils.table_to_sheet(tables,xlsxParam)
  // if(!wb['!merges']){
  //   this.$message.warning('无法导出：报表无数据')
  //   return
  // }
  for(var i=0;i<11;i++){
    wb['!cols'][i]={wpx:130}
  }
  for(const key in wb){
    if(key.indexOf("!")===-1){
      if(key.indexOf("1")===-1){
        wb[key].s={
          font:{//字体设置
            sz:13,
            bold:false,
            color:{
              rgb:'000000'
            }
          },
          alignment:{//文字居中
            horizontal:'center',
            vertical:'center',
            wrap_text:true
          },
          border:{//设置边框
            top:{style:'thin'},
            bootm:{style:'thin'},
            left:{style:'thin'},
            right:{style:'thin'}
          }
        }
      }else{
        wb[key].s={
          font:{//字体设置
            sz:13,
            bold:true,
            color:{
              rgb:'000000'
            }
          },
          fill:{
            fgColor:{
              rgb:'00BFFF'
            }
          },
          alignment:{//文字居中
            horizontal:'center',
            vertical:'center',
            wrap_text:true
          },
          border:{//设置边框
            top:{style:'thin'},
            bootm:{style:'thin'},
            left:{style:'thin'},
            right:{style:'thin'}
          }
        }
      }
    }
  }
  // var data=this.addRangeBorder(wb[!merges],wb)
  var filedata=sheet2blob(wb)
  openDownloadDialog(filedata,excel_name+'.xlsx')
}

//将一个sheet转成最终的excel文件的blob对象，然后利用URL.createObjectURL下载
const sheet2blob=(sheet,sheetName)=>{
  sheetName=sheetName||'sheet1'
  var workbook={
    SheetNames:[sheetName],
    Sheets:{}
  }
  workbook.Sheets[sheetName]=sheet
  var wopts={
    bookType:'xlsx',
    bookSST:false,
    type:'binary'
  }
  var wbout=XLSX2.write(workbook,wopts)
  var blob=new Blob([s2ab(wbout)],{
    type:'application/octet-stream'
  })
  function s2ab(s){
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }
  return blob
}

//模板下载
const openDownloadDialog=(url,saveName)=>{
  if (typeof url == 'object' && url instanceof Blob) {
      url = URL.createObjectURL(url); // 创建blob地址
  }
  var aLink = document.createElement('a');
  aLink.href = url;
  aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
  var event;
  if (window.MouseEvent) event = new MouseEvent('click');
  else {
      event = document.createEvent('MouseEvents');
      event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
  }
  aLink.dispatchEvent(event);
}

//模板单元格合并
const addRangeBorder=(range,ws)=>{
  let arr = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"]
  range.forEach(item=>{
    let startColNumber=Number(item.s.r),endColNumber=Number(item.e.r)
    let startRowNumber=Number(item.s.c),endRowNumber=Number(item.e.c)
    const test=ws[arr[startRowNumber] + (startColNumber + 1)]
    for(let col=startColNumber;col<=endColNumber;col++){
      for(let row=startRowNumber;row<=endRowNumber;row++){
        ws[arr[row]+(col+1)]=test
      }
    }
  })
  return ws
}

//字符串转日期格式
const getDate=(strDate)=>{
  console.log(strDate)
  var st=strDate
  var a=st.split(" ")
  var b=a[0].split("-")
  var c=a[1].split(":")
  var date=new Date(b[0],b[1],b[2],c[0],c[1],c[2])
  return dateFormatter(date,'yyyy-MM-dd hh:mm:ss')
}

//时间格式
const dateFormatter=(date,fmt)=>{
  let o = {
      "M+": date.getMonth() + 1,     //月份
      "d+": date.getDate(),     //日
      "h+": date.getHours(),     //小时
      "m+": date.getMinutes(),     //分
      "s+": date.getSeconds(),     //秒
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      "S": date.getMilliseconds()    //毫秒
  };
  if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (let k in o)
      if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

//时间戳转日期格式
const genDateFromStamp=(timeStamp)=>{
  let date = new Date(parseInt(timeStamp));
  let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
  let currentDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  let minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  return date.getFullYear() + "-" + month + "-" + currentDate + " " + hour + ":" + minute;
}

//配置请求头
const axios_set=()=>{
  axios.defaults.headers={
    "scctoken": localStorage.getItem(localStorage.getItem('userName')+'token'),
    "content-type":"application/x-www-form-urlencoded"
  },
  axios.defaults.timeout=15000
  //设置全局的请求次数，请求间隙
  // axios.defaults.retry=2 //请求次数
  // axios.defaults.retryDelay=3000 //请求间隙

  // axios.interceptors.response.use(undefined,function axiosRetryInterceptor(err){
  //   console.log(err)
  //   var config=err.config
  //   if(!config||!config.retry) return Promise.reject(err)
  //   config.__retryCount=config.__retryCount||0
  //   if(config.__retryCount>=config.retry){
  //     return Promise.reject(err)
  //   }
  //   config.__retryCount+=1
  //   var backoff = new Promise(function(resolve) {
  //       setTimeout(function() {
  //           resolve();
  //       }, config.retryDelay || 1)
  //   })
  //   return backoff.then(function() {
  //       return axios(config)
  //   })
  // })
}

//获取当前用户按钮权限
axios({
  method:'get',
  url:extra_path+'/admin/user/permission',
  headers:{
    "scctoken": localStorage.getItem(localStorage.getItem('userName')+'token'),
    "content-type":"application/x-www-form-urlencoded"
  }
}).then(data=>{
  if(data.data.success==true){
    localStorage.setItem(localStorage.getItem('userName')+'permission',JSON.stringify(data.data.data))
  }else{
    // Message.error(data.data.message)
    // setTimeout(function(){
    //   Router.push({path:'/'})
    // },1000)
  }
})

const transformRequest=function (obj) {
  var str = []
  for (var p in obj) {
    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]))
  }
  return str.join("&")
}

export default {
  env,
  env1,
  env2,
  axios_set,
  transformRequest,
  extra_path,
  bg_path,
  image_path,
  //模板下载相关
  exportToExcel,
  sheet2blob,
  openDownloadDialog,
  addRangeBorder,
  getDate,
  dateFormatter,
  //时间戳转日期格式
  genDateFromStamp
}



//////////////////
// WEBPACK FOOTER
// ./static/customizeRequestInfo.js
// module id = null
// module chunks = 